import Status from './Status.vue';

export default Status;
